/* istanbul ignore file */
import { UpdateForm } from 'framework/form';
import useActivityService from 'domain/sales/shared/timeline/activity/crmActivityService';
import ActivityForm from 'domain/sales/shared/timeline/activity/form/ActivityForm';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';
import { useCompositeDocumentStorageContext, useCompositeDocumentStorageService } from 'domain/shared/documentStorage';
import { ENTITY_DOCUMENT_TYPE } from 'domain/sales/opportunity/shared/constants';

const UpdateActivityForm = ({ getDataFunc, onCancel, ...props }: any) => {
  const { getValidationSchema, update } = useActivityService();

  const { isDocumentStorageAvailable } = useCompositeDocumentStorageContext();
  const { commitDocument } = useCompositeDocumentStorageService(isDocumentStorageAvailable);

  return (
    <UpdateForm
      getDataFunc={getDataFunc}
      submitFormFunc={async (id, values) => {
        const artifactPath = values?.artifactPaths;
        const commitData = await commitDocument(artifactPath, ENTITY_DOCUMENT_TYPE.ACTIVITY_DOCUMENT);
        return update(id, { ...values, artifactPaths: commitData });
      }}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <ActivityForm isEditForm />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdateActivityForm;
